/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdSearchResponseDto } from '../../models/ad-search-response-dto';

export interface AdControllerSearch$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어 (제목, 내용)
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 수신자 타입
 */
  memberRole?: 'PARENT' | 'TEACHER';
}

export function adControllerSearch(http: HttpClient, rootUrl: string, params: AdControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<AdSearchResponseDto>> {
  const rb = new RequestBuilder(rootUrl, adControllerSearch.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('memberRole', params.memberRole, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdSearchResponseDto>;
    })
  );
}

adControllerSearch.PATH = '/api/ad/search';
